import React, { useState } from 'react';

const ProductFilter = ({ brands, onFilterChange, selectedBrand, onSortChange, selectedSort, showBrandFilter, audioSubfilter, setAudioSubfilter }) => {
  const [showBrandFilterModal, setShowBrandFilterModal] = useState(false);
  const [showSortFilter, setShowSortFilter] = useState(false);

  return (
    <div className="mb-6 px-3 py-3 bg-white rounded-xl shadow-2xl border border-gray-100 min-h-[56px] flex items-center">
      {/* Versión móvil - Botones compactos */}
      <div className="lg:hidden flex gap-3 w-full justify-center items-center">
        {showBrandFilter && (
          <button
            onClick={() => setShowBrandFilterModal(true)}
            className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
              selectedBrand !== 'Todas'
                ? 'bg-black text-white shadow-md'
                : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
            }`}
            style={selectedBrand === 'Todas' ? { boxShadow: 'inset 2px 2px 8px #bbb, inset -2px -2px 8px #fff' } : {}}
          >
            Filtrar: {selectedBrand}
          </button>
        )}
        <button
          onClick={() => setShowSortFilter(true)}
          className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
            selectedSort !== 'default'
              ? 'bg-black text-white shadow-md'
              : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
          }`}
          style={selectedSort === 'default' ? { boxShadow: 'inset 2px 2px 8px #bbb, inset -2px -2px 8px #fff' } : {}}
        >
          Ordenar: {selectedSort === 'default' ? 'Predeterminado' : selectedSort === 'price-asc' ? 'Menor a Mayor' : 'Mayor a Menor'}
        </button>
      </div>

      {/* Modal de opciones de filtro por marca - móvil */}
      {showBrandFilter && showBrandFilterModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
          <div className="bg-white rounded-xl shadow-2xl p-4 w-11/12 max-w-xs mx-auto">
            <h3 className="text-base font-semibold text-gray-800 mb-3 text-center">Filtrar por Marca</h3>
            <div className="flex flex-wrap gap-2 justify-center mb-4">
              <button
                onClick={() => {
                  onFilterChange('Todas');
                  setShowBrandFilterModal(false);
                }}
                className={`px-3 py-1 rounded text-xs font-medium transition-colors ${
                  selectedBrand === 'Todas'
                    ? 'bg-black text-white'
                    : 'bg-white text-gray-700 hover:bg-gray-200'
                }`}
              >
                Todas
              </button>
              {brands.map(brand => (
                <button
                  key={brand}
                  onClick={() => {
                    onFilterChange(brand);
                    setShowBrandFilterModal(false);
                  }}
                  className={`px-3 py-1 rounded text-xs font-medium transition-colors ${
                    selectedBrand === brand
                      ? 'bg-black text-white'
                      : 'bg-white text-gray-700 hover:bg-gray-200'
                  }`}
                >
                  {brand}
                </button>
              ))}
            </div>
            <button
              onClick={() => setShowBrandFilterModal(false)}
              className="w-full py-2 rounded-lg bg-gray-200 text-gray-700 font-medium mt-2"
            >
              Cancelar
            </button>
          </div>
        </div>
      )}

      {/* Modal de opciones de ordenamiento - móvil */}
      {showSortFilter && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
          <div className="bg-white rounded-xl shadow-2xl p-4 w-11/12 max-w-xs mx-auto">
            <h3 className="text-base font-semibold text-gray-800 mb-3 text-center">Ordenar por Precio</h3>
            <div className="flex flex-col gap-2 mb-4">
              <button
                onClick={() => {
                  onSortChange('default');
                  setShowSortFilter(false);
                }}
                className={`px-3 py-1 rounded text-xs font-medium transition-colors ${
                  selectedSort === 'default'
                    ? 'bg-black text-white'
                    : 'bg-white text-gray-700 hover:bg-gray-200'
                }`}
              >
                Predeterminado
              </button>
              <button
                onClick={() => {
                  onSortChange('price-asc');
                  setShowSortFilter(false);
                }}
                className={`px-3 py-1 rounded text-xs font-medium transition-colors ${
                  selectedSort === 'price-asc'
                    ? 'bg-black text-white'
                    : 'bg-white text-gray-700 hover:bg-gray-200'
                }`}
              >
                Menor a Mayor
              </button>
              <button
                onClick={() => {
                  onSortChange('price-desc');
                  setShowSortFilter(false);
                }}
                className={`px-3 py-1 rounded text-xs font-medium transition-colors ${
                  selectedSort === 'price-desc'
                    ? 'bg-black text-white'
                    : 'bg-white text-gray-700 hover:bg-gray-200'
                }`}
              >
                Mayor a Menor
              </button>
            </div>
            <button
              onClick={() => setShowSortFilter(false)}
              className="w-full py-2 rounded-lg bg-gray-200 text-gray-700 font-medium mt-2"
            >
              Cancelar
            </button>
          </div>
        </div>
      )}

      {/* Versión escritorio - Layout original */}
      <div className="hidden lg:flex w-full">
        {showBrandFilter ? (
          <div className="flex flex-row justify-between gap-8 items-start w-full">
            {/* Filtro por Marca */}
            <div className="flex flex-col items-start flex-1 min-w-0 py-1">
              <h3 className="text-lg font-semibold text-gray-800 mb-2">Filtrar</h3>
              <div className="flex flex-wrap gap-3 items-center">
                {/* Solo mostrar botones de marca si NO es AUDIO */}
                {!(audioSubfilter && setAudioSubfilter) && (
                  <>
                    <button
                      onClick={() => onFilterChange('Todas')}
                      className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
                        selectedBrand === 'Todas'
                          ? 'bg-black text-white shadow-md'
                          : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                      }`}
                      style={selectedBrand !== 'Todas' ? { boxShadow: 'inset 2px 2px 8px #bbb, inset -2px -2px 8px #fff' } : {}}
                    >
                      Todas
                    </button>
                    {brands.map(brand => (
                      <button
                        key={brand}
                        onClick={() => onFilterChange(brand)}
                        className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
                          selectedBrand === brand
                            ? 'bg-black text-white shadow-md'
                            : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                        }`}
                        style={selectedBrand !== brand ? { boxShadow: 'inset 2px 2px 8px #bbb, inset -2px -2px 8px #fff' } : {}}
                      >
                        {brand}
                      </button>
                    ))}
                  </>
                )}
                {/* Subfiltros de AUDIO en la misma fila */}
                {audioSubfilter && setAudioSubfilter && (
                  ['Todos', 'Parlantes', 'Auriculares', 'Barras de sonido'].map(sub => (
                    <button
                      key={sub}
                      onClick={() => setAudioSubfilter(sub)}
                      className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors ${audioSubfilter === sub ? 'bg-black text-white shadow-md' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'}`}
                      style={audioSubfilter !== sub ? { boxShadow: 'inset 2px 2px 8px #bbb, inset -2px -2px 8px #fff', marginLeft: '4px' } : { marginLeft: '4px' }}
                    >
                      {sub}
                    </button>
                  ))
                )}
              </div>
            </div>
            {/* Ordenamiento por Precio alineado a la derecha */}
            <div className="flex flex-col items-end flex-shrink-0 min-w-[340px] pr-2 pb-4 py-1">
              <h3 className="text-lg font-semibold text-gray-800 mb-2 text-right">Ordenar por Precio</h3>
              <div className="flex flex-wrap gap-3 justify-end">
                <button
                  onClick={() => onSortChange('default')}
                  className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
                    selectedSort === 'default'
                      ? 'bg-black text-white shadow-md'
                      : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                  }`}
                  style={selectedSort !== 'default' ? { boxShadow: 'inset 2px 2px 8px #bbb, inset -2px -2px 8px #fff' } : {}}
                >
                  Predeterminado
                </button>
                <button
                  onClick={() => onSortChange('price-asc')}
                  className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
                    selectedSort === 'price-asc'
                      ? 'bg-black text-white shadow-md'
                      : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                  }`}
                  style={selectedSort !== 'price-asc' ? { boxShadow: 'inset 2px 2px 8px #bbb, inset -2px -2px 8px #fff' } : {}}
                >
                  Menor a Mayor
                </button>
                <button
                  onClick={() => onSortChange('price-desc')}
                  className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
                    selectedSort === 'price-desc'
                      ? 'bg-black text-white shadow-md'
                      : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                  }`}
                  style={selectedSort !== 'price-desc' ? { boxShadow: 'inset 2px 2px 8px #bbb, inset -2px -2px 8px #fff' } : {}}
                >
                  Mayor a Menor
                </button>
              </div>
            </div>
          </div>
        ) : (
          <div className="flex flex-row justify-end items-start w-full">
            {/* Ordenamiento por Precio alineado a la derecha, ocupa todo el ancho */}
            <div className="flex flex-col items-end flex-shrink-0 min-w-[340px] pr-2 pb-4 py-1">
              <h3 className="text-lg font-semibold text-gray-800 mb-2 text-right">Ordenar por Precio</h3>
              <div className="flex flex-wrap gap-3 justify-end">
                <button
                  onClick={() => onSortChange('default')}
                  className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
                    selectedSort === 'default'
                      ? 'bg-black text-white shadow-md'
                      : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                  }`}
                  style={selectedSort !== 'default' ? { boxShadow: 'inset 2px 2px 8px #bbb, inset -2px -2px 8px #fff' } : {}}
                >
                  Predeterminado
                </button>
                <button
                  onClick={() => onSortChange('price-asc')}
                  className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
                    selectedSort === 'price-asc'
                      ? 'bg-black text-white shadow-md'
                      : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                  }`}
                  style={selectedSort !== 'price-asc' ? { boxShadow: 'inset 2px 2px 8px #bbb, inset -2px -2px 8px #fff' } : {}}
                >
                  Menor a Mayor
                </button>
                <button
                  onClick={() => onSortChange('price-desc')}
                  className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
                    selectedSort === 'price-desc'
                      ? 'bg-black text-white shadow-md'
                      : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                  }`}
                  style={selectedSort !== 'price-desc' ? { boxShadow: 'inset 2px 2px 8px #bbb, inset -2px -2px 8px #fff' } : {}}
                >
                  Mayor a Menor
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ProductFilter;